import "../css/shippingPolicy.css";
import {
  FaShippingFast,
  FaBoxOpen,
  FaTruck,
  FaMapMarkedAlt,
  FaClock,
  FaExclamationTriangle,
} from "react-icons/fa";

function ShippingPolicy() {
  return (
    <div className="shipping-page">

      {/* Hero */}

      <section className="shipping-hero">

        <div className="shipping-overlay">

          <h1>Shipping Policy</h1>

          <p>
            Fast, secure, and reliable delivery is our priority.
            Learn about our shipping process and delivery timelines.
          </p>

        </div>

      </section>

      {/* Introduction */}

      <section className="shipping-section">

        <div className="shipping-container">

          <h2>Shipping Information</h2>

          <p>
            SIP LIQUORS is committed to delivering your orders safely and
            on time. Orders are processed quickly and shipped using trusted
            delivery partners.
          </p>

        </div>

      </section>

      {/* Shipping Cards */}

      <section className="shipping-section gray">

        <div className="shipping-container">

          <div className="shipping-grid">

            <div className="shipping-card">
              <FaBoxOpen className="shipping-icon" />
              <h3>Order Processing</h3>
              <p>
                Orders are processed within 1–2 business days after
                successful payment confirmation.
              </p>
            </div>

            <div className="shipping-card">
              <FaTruck className="shipping-icon" />
              <h3>Fast Delivery</h3>
              <p>
                Most orders are delivered within 3–7 business days
                depending on your location.
              </p>
            </div>

            <div className="shipping-card">
              <FaMapMarkedAlt className="shipping-icon" />
              <h3>Delivery Areas</h3>
              <p>
                We currently deliver to eligible locations where alcohol
                delivery is legally permitted.
              </p>
            </div>

            <div className="shipping-card">
              <FaClock className="shipping-icon" />
              <h3>Delivery Time</h3>
              <p>
                Delivery estimates may vary during holidays,
                weekends, and severe weather conditions.
              </p>
            </div>

          </div>

        </div>

      </section>

      {/* Timeline */}

      <section className="shipping-section">

        <div className="shipping-container">

          <h2>Shipping Process</h2>

          <div className="shipping-timeline">

            <div className="timeline-item">
              <FaBoxOpen className="timeline-icon" />
              <h3>Order Placed</h3>
              <p>Your order has been successfully received.</p>
            </div>

            <div className="timeline-item">
              <FaShippingFast className="timeline-icon" />
              <h3>Processing</h3>
              <p>Your products are packed securely.</p>
            </div>

            <div className="timeline-item">
              <FaTruck className="timeline-icon" />
              <h3>Shipped</h3>
              <p>Your order is on the way to your address.</p>
            </div>

            <div className="timeline-item">
              <FaMapMarkedAlt className="timeline-icon" />
              <h3>Delivered</h3>
              <p>Enjoy your premium products safely.</p>
            </div>

          </div>

        </div>

      </section>

      {/* Rules */}

      <section className="shipping-section gray">

        <div className="shipping-container">

          <h2>Shipping Guidelines</h2>

          <ul className="shipping-list">

            <li>✔ Valid government-issued ID may be required upon delivery.</li>

            <li>✔ Customers must meet the legal drinking age.</li>

            <li>✔ Someone must be available to receive the package.</li>

            <li>✔ Incorrect addresses may delay shipment.</li>

            <li>✔ Shipping charges are calculated during checkout.</li>

            <li>✔ Delivery availability depends on local laws.</li>

          </ul>

        </div>

      </section>

      {/* Bottom */}

      <section className="shipping-bottom">

        <div className="shipping-container">

          <FaExclamationTriangle className="bottom-warning" />

          <h2>Need Help With Shipping?</h2>

          <p>
            If you have any questions regarding your shipment,
            please contact our customer support team.
          </p>

        </div>

      </section>

    </div>
  );
}

export default ShippingPolicy;